var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.625C7.32107 5.625 9 4.78553 9 3.75C9 2.71447 7.32107 1.875 5.25 1.875C3.17893 1.875 1.5 2.71447 1.5 3.75C1.5 4.78553 3.17893 5.625 5.25 5.625Z",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.75C1.5 3.75 1.5 5.33948 1.5 6.375C1.5 7.41052 3.17893 8.25 5.25 8.25C7.32105 8.25 9 7.41052 9 6.375C9 5.76165 9 3.75 9 3.75",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.375C1.5 6.375 1.5 7.96448 1.5 9C1.5 10.0355 3.17893 10.875 5.25 10.875C7.32105 10.875 9 10.0355 9 9C9 8.38665 9 6.375 9 6.375",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 9 1.5 10.5895 1.5 11.625C1.5 12.6605 3.17893 13.5 5.25 13.5C7.32105 13.5 9 12.6605 9 11.625C9 11.0117 9 9 9 9",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.625C1.5 11.625 1.5 13.2145 1.5 14.25C1.5 15.2855 3.17893 16.125 5.25 16.125C7.32105 16.125 9 15.2855 9 14.25C9 13.6367 9 11.625 9 11.625",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.875C14.8211 10.875 16.5 10.0355 16.5 9C16.5 7.96447 14.8211 7.125 12.75 7.125C10.6789 7.125 9 7.96447 9 9C9 10.0355 10.6789 10.875 12.75 10.875Z",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9 9 9 10.5895 9 11.625C9 12.6605 10.679 13.5 12.75 13.5C14.821 13.5 16.5 12.6605 16.5 11.625C16.5 11.0117 16.5 9 16.5 9",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.625C9 11.625 9 13.2145 9 14.25C9 15.2855 10.679 16.125 12.75 16.125C14.821 16.125 16.5 15.2855 16.5 14.25C16.5 13.6367 16.5 11.625 16.5 11.625",
    stroke: "#325880",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.323f071b0dc255ad481b63159d59ffe8.svg";
export { ForwardRef as ReactComponent };